//@ts-nocheck

import React, { PropsWithChildren, useCallback, useState } from 'react';
import { createContext } from 'use-context-selector';

import { TableContextState, TableProviderProps } from './types';

// import {
//   PaymentApiResult,
//   PaymentCreditCardState,
//   TableContextState,
//   TableMethods,
//   TableProductInfo,
//   TableProviderProps,
// } from 'features/payments/types';
// import { TableAccountState, PaymentsLeadState } from '.';

export const TableContext = createContext({} as TableContextState);

// const TableWrapper = styled.div`
//   position: relative;
//   width: calc(100vw - 320px);
//   overflow-x: auto;
// `;

export const TableProvider = React.memo(
  ({ children, fixedTop }: PropsWithChildren<TableProviderProps>) => {
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const [triggerSelectMultipleRows, setTriggerSelectMultipleRows] = useState(false);

    const checkSelectedRow = useCallback(
      (rowKey: string) => {
        return !!selectedRows.find((selectedRow) => selectedRow === rowKey);
      },
      [selectedRows]
    );

    const selectMultipleRows = (rows: string[]) => {
      setSelectedRows(rows);
    };

    const handleSelectRow = useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        const { checked, value } = event.currentTarget;

        if (checked) {
          if (!checkSelectedRow(value)) {
            setSelectedRows((prevSelectedRows) => [...prevSelectedRows, value]);
          }
        } else {
          setSelectedRows(selectedRows.filter((selectedRow) => selectedRow !== value));
        }
      },
      [selectedRows]
    );

    // const [, setScrollPosition] = useState(0);

    // const handleScroll = () => {
    //   const position = window.pageYOffset;
    //   setScrollPosition(position);
    // };

    // const tableOffset = () => {
    //   const pageHeight = window.innerHeight;
    //   const tableWrapper = document.getElementById('melverTableWrapper');

    //   if (tableWrapper) {
    //     const tableHeight = pageHeight - tableWrapper?.offsetTop;

    //     tableWrapper.style.height = `${tableHeight}px`;

    //     console.log('melverTableWrapper', tableHeight);
    //   }
    // };

    // useEffect(() => {
    //   tableOffset();

    //   window.addEventListener('scroll', handleScroll);

    //   return () => {
    //     window.removeEventListener('scroll', handleScroll);
    //   };
    // }, []);

    return (
      <TableContext.Provider
        value={{
          selectedRows,
          handleSelectRow,
          checkSelectedRow,
          selectMultipleRows,
          triggerSelectMultipleRows,
          setTriggerSelectMultipleRows,
        }}
      >
        {children}
      </TableContext.Provider>
    );
  }
);
